// Imperative entry point to the Security PIN dialog (SecurityPinHost, mounted once in the
// dashboard shell) — the web counterpart of mobile's SecurePinResultBus.

export interface SecurityPinRequest {
  // 'verify': ask for the PIN (or make the user set one first), then run onSuccess.
  // 'change': OTP → new PIN, no old PIN asked (Security page "Change / Set Security PIN").
  mode: 'verify' | 'change'
  // What is being protected (analytics `Flow`)
  flow: string
  onSuccess: () => void
}

type Host = (request: SecurityPinRequest) => void
let host: Host | null = null

export const registerSecurityPinHost = (next: Host | null) => {
  host = next
}

// Runs `onSuccess` once the user has proved (or just set) their Security PIN. Where no host is
// mounted (legacy pages outside the new dashboard) the action runs as it always did.
export const requireSecurityPin = (flow: string, onSuccess: () => void) => {
  if (host) {
    host({ mode: 'verify', flow, onSuccess })
  } else {
    onSuccess()
  }
}

export const changeSecurityPin = (flow: string, onSuccess: () => void = () => {}) => {
  if (host) {
    host({ mode: 'change', flow, onSuccess })
  }
}
